import React from "react";
import ReclamationCard from "./ReclamationCard";
import BreadCrumb from "../../../layout/BreadCrumb";
import LeafletMap from "./LeafletMap";

function ReclamationOverview() {
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb breadcrumbs={[{ title: "Land Reclamation Overview" }]} />
      <div className="white_card mt-[1.25rem] flex-1  ">
        <div className="form-add-h !text-darkBlue">
          Land Reclamation Overview
        </div>
        <ReclamationCard />

        <div className="mt-[1.75rem]">
          {" "}
          <LeafletMap />
        </div>
      </div>
    </div>
  );
}

export default ReclamationOverview;
